import { VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

export const SectionInnerCard: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return useBreakpointValue({
    base: (
      <Box p={Spacing['inset.sm']} bgColor={Color['neutral.white']} borderRadius={BoxBorder.heavy}>
        <VStack w="full" space={Spacing['stack.xxs']}>
          {children}
        </VStack>
      </Box>
    ),
    sm: (
      <VStack w="full" space={Spacing['stack.xxs']}>
        {children}
      </VStack>
    ),
  });
};
